<template>
  <div>
    <h1>LOGIN</h1>
    <error-display v-bind:error="error"></error-display>
    <p>
      Currently, early access via:
      <a
        class="patreon-button"
        href="https://www.patreon.com/c/rpgRoot/membership"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Join us on Patreon"
      >
        <img
          id="patreonLogo"
          src="../assets/patreon.svg"
          alt="Patreon"
          width="170"
        />
      </a>
    </p>
    <form @submit.prevent="sendLoginForm">
      <label
        >Login:
        <input type="text" v-model="login" />
      </label>
      <br />
      <label
        >Password:
        <input type="password" v-model="password" />
      </label>
      <br />
      <br />
      <input id="submitBtn" type="submit" value="LOGIN" />
    </form>
    <br />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import ErrorDisplay from '../components/ErrorDisplay.vue';
import { ErrorInfo } from '../network';
import { Requester } from '../requester';

@Options({
  components: { ErrorDisplay },
  data() {
    return {
      loginResult: '',
      error: new ErrorInfo(),
      login: '',
      password: ''
    };
  },
  methods: {
    async sendLoginForm() {
      const result = await Requester.post<any>('login', {
        loginData: this.login,
        password: this.password
      });

      if (!('data' in result)) {
        // In case of failed to fetch at all
        this.error = result;
      } else {
        if (result.data.status === 'ok') {
          // Refresh to get new content for logged in user
          setTimeout(() => {
            location.assign('https://play.rpgroot.com');
          }, 1000);
        } else {
          this.error = new ErrorInfo(
            result.data.errorMessage,
            result.data.errorCode,
            '...'
          );
        }
      }
    }
  }
})
export default class Login extends Vue {}
</script>

<style>
input {
  width: 200px;
  padding: 5px 7px;
  margin: 5px;
}
form {
  margin-top: 50px;
}
#patreonLogo {
  vertical-align: middle;
  background-color: #ffffff;
  margin: 0px 10px;
}
.patreon-button {
  align-items: center;
}
#submitBtn {
  width: 150px;
  height: 50px;
}
</style>
